import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class ConfigGroupsStore {
  constructor (rootStore) {
    this.state = {
      permissions: [],
      isFetching: false,
      isCreating: false,
      isUpdating: false,
      createGroupModalIsActive: false,
      editGroupModalIsActive: false,
      newGroup: {
        name: '',
        permissions: []
      },
      editGroup: {
        id: '',
        name: '',
        permissions: []
      }
    }
    this.stores = rootStore.stores
    this.fetchAllPermissions()
  }

  get groups () {
    return this.stores.profilesStore.state.profiles.sort((current, next) => current.name.localeCompare(next.name))
  }

  openCreateGroupModal () {
    this.state.createGroupModalIsActive = true
  }

  closeCreateGroupModal () {
    this.state.createGroupModalIsActive = false
  }

  openEditGroupModal () {
    this.state.editGroupModalIsActive = true
  }

  closeEditGroupModal () {
    this.state.editGroupModalIsActive = false
  }

  setNewGroupName (name) {
    this.state.newGroup.name = name
  }

  fetchAllPermissions () {
    const url = process.env.REACT_APP_AWS_URL + '/getAllPermissions/'
    axios.post(url)
      .then(response => {
        console.log(response)
        this.state.permissions = response.data
      })
      .catch(error => {
        console.log(error)
      })
  }

  setNewGroupPermissions (permissions) {
    this.state.newGroup.permissions = permissions.map(data => data.value)
  }

  createGroup () {
    this.state.isCreating = true
    const url = process.env.REACT_APP_AWS_URL + '/createGroup/'
    const id = this.state.newGroup.name.replace(' ', '_')
    if (this.groups.some(data => data.id === id)) {
      this.stores.notificationStore.sendErrorNotification('Erro!', 'Já existe um grupo com o ID gerado')
      this.state.isCreating = false
      return
    }
    const newProfile = {
      id: id,
      name: this.state.newGroup.name,
      permissions: this.state.newGroup.permissions
    }
    axios.post(url, newProfile)
    .then(response => {
      console.log(response)
      this.state.isCreating = false
      this.stores.profilesStore.addProfile(newProfile)
      this.closeCreateGroupModal()
    })
    .catch(error => {
      console.log(error)
      this.state.isCreating = false
    })
  }

  updateGroup () {
    this.state.isUpdating = true
    const url = process.env.REACT_APP_AWS_URL + '/createGroup/'
    const updatedProfile = {
      id: this.state.editGroup.id,
      name: this.state.editGroup.name,
      permissions: this.state.editGroup.permissions
    }
    axios.post(url, updatedProfile)
    .then(response => {
      console.log(response)
      this.state.isUpdating = false
      this.stores.profilesStore.updateProfile(updatedProfile)
      this.closeEditGroupModal()
    })
    .catch(error => {
      console.log(error)
      this.state.isUpdating = false
    })
  }

  setEditGroup (group) {
    this.state.editGroup.id = group.id
    this.state.editGroup.name = group.name
    this.state.editGroup.permissions = group.permissions
  }

  setEditGroupName (name) {
    this.state.editGroup.name = name
  }

  setEditGroupPermissions (selectedPermissions) {
    this.state.editGroup.permissions = selectedPermissions.map(data => data.value)
  }
}

decorate(ConfigGroupsStore, {
  state: observable
})

export default ConfigGroupsStore



// WEBPACK FOOTER //
// ./src/stores/config/configGroupsStore.js